/**
 * <s-bottom-nav> — phone-only app-style tab bar.
 * Mirrors the header cart count (data-cart-count on #header-cart-trigger, refreshed by
 * the cart-count partial after each cart mutation) into its own [data-bottom-nav-cart-count] badge.
 * Wishlist badges use [data-wishlist-count] and are kept in sync by s-wishlist.js.
 */
class BottomNav extends HTMLElement {
  #observer;

  connectedCallback() {
    const header = document.querySelector('[data-header-nav-group]');
    this.#sync();
    if (!header) return;
    this.#observer = new MutationObserver(() => this.#sync());
    this.#observer.observe(header, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-count'] });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #sync() {
    const trigger = document.getElementById('header-cart-trigger');
    const badge = this.querySelector('[data-bottom-nav-cart-count]');
    if (!trigger || !badge) return;
    const count = Number(trigger.dataset.cartCount || 0);
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.hidden = count < 1;
  }
}

if (!customElements.get('s-bottom-nav')) customElements.define('s-bottom-nav', BottomNav);
